/** The state a successful request with nothing in it renders. Never an error. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./EmptyState.css";

export interface EmptyStateProps {
  readonly headline: ReactNode;
  readonly body?: ReactNode;
  readonly action?: ReactNode;
  /** No frame, for an empty state already inside a panel. */
  readonly bare?: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function EmptyState({ headline, body, action, bare = false, className, style }: EmptyStateProps) {
  return (
    <div className={cn("al-empty", bare ? "al-empty-bare" : undefined, className)} style={style}>
      <div className="al-empty-headline">{headline}</div>
      {body !== undefined ? <div className="al-empty-body">{body}</div> : null}
      {action !== undefined ? <div className="al-empty-action">{action}</div> : null}
    </div>
  );
}
